"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useAuthStore } from "@/store/auth";

export default function StoreLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  // 비로그인 정책 (2026-05-30 Stage 1~7 후):
  //  - /store, /store/dashboard, /store/menus, /store/sales, /store/stock, /store/tax, /store/staff:
  //    데모 페이지 — 페이지 자체에서 예시카페 데이터 + 블러 + CTA 처리. 로그인 강제 X.
  //  - /store/setup, /store/manage, /store/checklist, /store/staff/payslip/* 등:
  //    실제 작업/데이터 필요 → 로그인 필수.
  const DEMO_PATHS = new Set([
    "/store", "/store/dashboard", "/store/menus", "/store/sales",
    "/store/stock", "/store/tax", "/store/staff",
  ]);
  const isDemoPath = DEMO_PATHS.has(pathname || "");

  useEffect(() => {
    if (!hasHydrated) return;
    if (!isLoggedIn && !isDemoPath) {
      router.replace(`/login?next=${encodeURIComponent(pathname || "/store")}`);
    }
  }, [hasHydrated, isLoggedIn, isDemoPath, pathname, router]);

  if (!hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-2 text-text-sub text-sm">
          <span className="w-4 h-4 border-2 border-text-sub/30 border-t-primary rounded-full animate-spin" />
          <span>로딩 중...</span>
        </div>
      </div>
    );
  }
  if (!isLoggedIn && !isDemoPath) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-text-sub text-sm">로그인 페이지로 이동 중...</p>
      </div>
    );
  }

  return <div className="pb-24 min-h-screen">{children}</div>;
}
